module.exports = __webpack_public_path__ + "static/img/Colla_Tale_2.3ead5e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/Colla_Tale_2.jpg
// module id = C79X
// module chunks = 0